import { render, staticRenderFns } from "./BenefitsTbRu.vue?vue&type=template&id=381cd91e"
import script from "./BenefitsTbRu.vue?vue&type=script&lang=js"
export * from "./BenefitsTbRu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports